export default "__VITE_ASSET__CTr7tQt2__"